import { ComponentTypes } from '@/Apps/Pages/Editor/types'
import Cursor from './Cursor'
import { ComponentRenderHooks } from '@/plugins/types'

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === ComponentTypes.CURSOR) {
    return [Cursor]
  }
}